"use client";

import { UseCasesSection } from "@/components/sections/use-cases";
import { useCases } from "@/lib/data/services-brand-protection-augmentation";

export function UseCases() {
  return (
    <UseCasesSection
      eyebrow={useCases.eyebrow}
      title={useCases.title}
      cases={useCases.cases}
      accent={useCases.accent}
    />
  );
}
